import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../utils/api';
import StatusBadge from '../components/StatusBadge';
import Spinner from '../components/Spinner';

// ─── Finansal Detay Bileşeni ──────────────────────────────────────────────────

function FinRow({ label, value, color, hint }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '7px 0', borderBottom: '1px solid #f1f5f9' }}>
      <div>
        <span style={{ fontSize: 13, color: '#64748b' }}>{label}</span>
        {hint && <span style={{ fontSize: 11, color: '#94a3b8', marginLeft: 6 }}>{hint}</span>}
      </div>
      <span style={{ fontSize: 14, fontWeight: 600, color: color || '#1e293b' }}>{value}</span>
    </div>
  );
}

function FinancialDetail({ financial }) {
  const products = financial.products || [];

  return (
    <div className="bg-white border border-gray-200 rounded-xl mt-6">
      <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
        <h2 className="font-semibold text-gray-800">💰 Finansal Detay</h2>
        <div style={{ display: 'flex', gap: 12, fontSize: 12, color: '#94a3b8' }}>
          <span>🇹🇷→🇷🇺 {financial.cluster_from || '—'} → {financial.cluster_to || '—'}</span>
        </div>
      </div>

      <div className="px-5 py-4">
        {/* Açıklama kutusu */}
        <div style={{
          background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10,
          padding: '10px 14px', marginBottom: 16, fontSize: 12, color: '#1d4ed8', lineHeight: 1.6,
        }}>
          <strong>Para birimleri hakkında:</strong> Listeleme fiyatı ve indirimler <strong>USD ($)</strong> cinsinden —
          Ozon'a ürünü kaç dolardan sattığınız. Müşteri ödemesi, payout ve komisyon ise <strong>₽ Ruble</strong>
          cinsinden — Ozon'un Rus müşteriden tahsil ettiği ve size aktardığı tutar.
        </div>

        {products.map((p, i) => {
          const listPrice    = Number(p.price || 0);       // USD — senin fiyatın
          const oldPrice     = Number(p.old_price || 0);   // USD — önceki fiyat
          const discountUsd  = Number(p.total_discount_value || 0); // USD
          const discountPct  = Number(p.total_discount_percent || 0);
          const customerRub  = Number(p.customer_price || 0);   // ₽
          const payoutRub    = Number(p.payout || 0);            // ₽
          const commRub      = Math.abs(Number(p.commission_amount || 0)); // ₽
          const commPct      = Number(p.commission_percent || 0);
          const qty          = Number(p.quantity || 1);
          const netRatePct   = customerRub > 0 ? ((payoutRub / customerRub) * 100).toFixed(0) : 0;

          return (
            <div key={i} style={{ marginBottom: products.length > 1 ? 20 : 0 }}>
              {products.length > 1 && (
                <div style={{ fontSize: 12, fontWeight: 600, color: '#6366f1', marginBottom: 8 }}>
                  Ürün {i + 1} — {p.product_id}
                </div>
              )}

              {/* USD blok */}
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: 1, marginBottom: 4 }}>
                  FİYAT BİLGİSİ (USD — Senin fiyatın)
                </div>
                {oldPrice > listPrice && (
                  <FinRow label="Orijinal Fiyat" value={`$ ${oldPrice.toFixed(2)}`} color="#94a3b8" />
                )}
                <FinRow label="İndirim" value={`- $ ${discountUsd.toFixed(2)} (% ${discountPct.toFixed(1)})`} color="#ef4444" />
                <FinRow label="Satış Fiyatı (indirimli)" value={`$ ${listPrice.toFixed(2)}`} color="#6366f1" />
              </div>

              {/* RUB blok */}
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: 1, marginBottom: 4 }}>
                  ÖDEME DETAYI (₽ Ruble — Ozon'dan gelen)
                </div>
                <FinRow label="Müşteri Ödemesi"     value={`₽ ${customerRub.toLocaleString('ru-RU')}`}  color="#6366f1"
                  hint={qty > 1 ? `(${qty} adet)` : ''} />
                <FinRow label="Ozon Komisyonu"       value={`- ₽ ${commRub.toLocaleString('ru-RU')} (% ${commPct})`} color="#ef4444" />
                <FinRow label="Net Payout (Sana)"    value={`₽ ${payoutRub.toLocaleString('ru-RU')}`}   color="#16a34a" />
              </div>

              {/* Özet bar */}
              <div style={{ marginTop: 14, background: '#f8fafc', borderRadius: 10, padding: '10px 14px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 12, color: '#64748b' }}>
                  <span>Müşteri ödemesinin sana kalan kısmı</span>
                  <span style={{ fontWeight: 700, color: '#16a34a' }}>{netRatePct}%</span>
                </div>
                <div style={{ height: 8, background: '#e2e8f0', borderRadius: 4, overflow: 'hidden', display: 'flex' }}>
                  <div style={{ width: netRatePct + '%', background: '#22c55e', borderRadius: 4 }} />
                  <div style={{ flex: 1, background: '#fbbf24' }} title="Komisyon" />
                </div>
                <div style={{ display: 'flex', gap: 12, marginTop: 6, fontSize: 11, color: '#94a3b8' }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ width: 8, height: 8, borderRadius: 2, background: '#22c55e', display: 'inline-block' }} />
                    Net payout
                  </span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ width: 8, height: 8, borderRadius: 2, background: '#fbbf24', display: 'inline-block' }} />
                    Komisyon ve diğer kesintiler
                  </span>
                </div>
              </div>

              {/* Uygulanan aksiyonlar */}
              {p.actions?.length > 0 && (
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: 1, marginBottom: 6 }}>
                    UYGULANAN İNDİRİM/AKSIYONLAR
                  </div>
                  {p.actions.map((a, j) => (
                    <div key={j} style={{ fontSize: 12, color: '#64748b', padding: '3px 0', display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ color: '#8b5cf6' }}>•</span> {a}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────

function fmt(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('tr-TR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

function isPast(iso) {
  return iso && new Date(iso) < new Date();
}

function isOverdueStatus(status) {
  return ['awaiting_packaging', 'awaiting_deliver'].includes(status);
}

function InfoRow({ label, value, type, highlight }) {
  const colorMap = { red: 'text-red-600', green: 'text-green-600' };
  const display = type === 'datetime' ? fmt(value) : (value || '—');
  return (
    <div>
      <div className="text-gray-400 text-xs uppercase tracking-wide mb-1">{label}</div>
      <div className={`font-medium ${highlight ? colorMap[highlight] : 'text-gray-800'}`}>
        {display}
      </div>
    </div>
  );
}

const EVENT_CONFIG = {
  order_created:    { icon: '🟢', color: 'text-green-700',  bg: 'bg-green-100'  },
  status_changed:   { icon: '🔄', color: 'text-blue-700',   bg: 'bg-blue-100'   },
  label_printed:    { icon: '🖨️', color: 'text-slate-700',  bg: 'bg-slate-100'  },
  label_assigned:   { icon: '🏷️', color: 'text-purple-700', bg: 'bg-purple-100' },
  label_unassigned: { icon: '🗑️', color: 'text-red-600',    bg: 'bg-red-100'    },
  note_added:       { icon: '📝', color: 'text-yellow-700', bg: 'bg-yellow-100' },
};

function fmtEvent(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('tr-TR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export default function OrderDetail() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState({});
  const [printing, setPrinting] = useState(null);
  const [printMsg, setPrintMsg] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    Promise.all([
      api.getOrder(id),
      api.getOrderEvents(id).catch(() => []),
    ])
      .then(([ord, evts]) => {
        setOrder(ord);
        setEvents(evts);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [id]);

  function toggleCheck(itemId) {
    setChecked((prev) => ({ ...prev, [itemId]: !prev[itemId] }));
  }

  async function handlePrint(type) {
    setPrinting(type);
    setPrintMsg(null);
    try {
      const endpoint =
        type === 'label'
          ? `/api/orders/${id}/label.pdf`
          : `/api/orders/${id}/packing-slip.pdf`;

      // PDF'i backend'den çekip blob olarak aç
      const token = localStorage.getItem('ozon_token');
      const res = await fetch(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ error: res.statusText }));
        throw new Error(err.error || 'PDF oluşturulamadı');
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      // Bellek sızıntısını önlemek için kısa süre sonra temizle
      setTimeout(() => URL.revokeObjectURL(url), 60000);

      setPrintMsg({ ok: true, type });
    } catch (e) {
      setPrintMsg({ ok: false, msg: e.message });
    } finally {
      setPrinting(null);
    }
  }

  if (loading) return <div className="flex justify-center py-16"><Spinner size="lg" /></div>;
  if (error) return <div className="p-8 text-red-600">{error}</div>;
  if (!order) return null;

  const items = (order.items || []).filter(Boolean);
  const allChecked = items.length > 0 && items.every((i) => checked[i.id]);
  const totalItems = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <div className="p-8 max-w-3xl">
      <div className="mb-6">
        <Link to="/orders" className="text-sm text-blue-600 hover:underline">← Siparişler</Link>
      </div>

      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-xl font-bold text-gray-900 font-mono">{order.posting_number}</h1>
          <p className="text-sm text-gray-500 mt-1">Sipariş #{order.order_id}</p>
        </div>
        <StatusBadge status={order.status} />
      </div>

      {/* Sipariş bilgileri */}
      <div className="bg-white border border-gray-200 rounded-xl p-5 mb-6 text-sm">
        <div className="grid grid-cols-2 gap-x-6 gap-y-4">
          <InfoRow label="Sisteme Giriş" value={order.created_at} type="datetime" />
          <InfoRow label="İşleme Alındı"
            value={order.raw_json?.in_process_at} type="datetime" />
          <InfoRow label="Sevk Son Tarihi" value={order.shipment_date} type="datetime"
            highlight={isOverdueStatus(order.status) && isPast(order.shipment_date) ? 'red' : null} />
          <InfoRow label="Gecikmesiz Sevk Tarihi"
            value={order.raw_json?.shipment_date_without_delay} type="datetime" />
          {order.delivering_date && (
            <InfoRow label="Gerçek Sevkiyat" value={order.delivering_date} type="datetime" highlight="green" />
          )}
          {(order.delivery_date_begin || order.delivery_date) && (
            <div>
              <div className="text-gray-400 text-xs uppercase tracking-wide mb-1">Planlanan Teslimat</div>
              <div className="font-medium text-gray-800">
                {order.delivery_date_begin
                  ? `${fmt(order.delivery_date_begin)} – ${fmt(order.delivery_date)}`
                  : fmt(order.delivery_date)}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Ürün listesi (checkbox'lı) */}
      <div className="bg-white border border-gray-200 rounded-xl mb-6">
        <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
          <h2 className="font-semibold text-gray-800">Ürünler ({totalItems} adet)</h2>
          {allChecked && (
            <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded font-medium">
              ✓ Tüm ürünler kontrol edildi
            </span>
          )}
        </div>
        <div className="divide-y divide-gray-50">
          {items.map((item) => (
            <label
              key={item.id}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-gray-50 transition-colors ${
                checked[item.id] ? 'bg-green-50' : ''
              }`}
            >
              <input
                type="checkbox"
                checked={!!checked[item.id]}
                onChange={() => toggleCheck(item.id)}
                className="h-5 w-5 rounded accent-green-600 cursor-pointer"
              />
              <div className="flex-1 min-w-0">
                <div className={`font-semibold text-sm ${checked[item.id] ? 'line-through text-gray-400' : 'text-gray-800'}`}>
                  {item.offer_id}
                </div>
                <div className="text-xs mt-0.5" style={{ color: '#999' }}>{item.name}</div>
              </div>
              <div className="text-right">
                <div className="text-sm font-semibold text-gray-700">{item.quantity} adet</div>
                <div className="text-xs text-gray-400">{item.price} $</div>
              </div>
            </label>
          ))}
        </div>
      </div>

      {/* Packing slip preview */}
      <div className="bg-white border border-gray-200 rounded-xl mb-6">
        <div className="px-5 py-4 border-b border-gray-100">
          <h2 className="font-semibold text-gray-800">Packing Slip Önizleme</h2>
        </div>
        <div className="p-5 font-mono text-sm text-gray-600 bg-gray-50 rounded-b-xl">
          <div className="border-b border-dashed border-gray-300 pb-3 mb-3">
            <div className="font-bold text-base text-gray-900">OZON FBS SİPARİŞ</div>
            <div>Posting: {order.posting_number}</div>
            <div>
              Tarih:{' '}
              {order.shipment_date
                ? new Date(order.shipment_date).toLocaleDateString('tr-TR')
                : '—'}
            </div>
          </div>
          {items.map((item, i) => (
            <div key={i} className="flex justify-between py-1">
              <div className="truncate mr-4">
                <div className="font-semibold">{item.offer_id}</div>
                <div className="text-xs font-normal" style={{ color: '#999' }}>{item.name}</div>
              </div>
              <span className="whitespace-nowrap self-center">{item.quantity} × {item.price} $</span>
            </div>
          ))}
          <div className="border-t border-dashed border-gray-300 mt-3 pt-3 font-bold text-gray-800 flex justify-between">
            <span>TOPLAM</span>
            <span>{items.reduce((s, i) => s + i.quantity * parseFloat(i.price || 0), 0).toFixed(2)} $</span>
          </div>
        </div>
      </div>

      {/* Print butonları */}
      {printMsg && (
        <div className={`mb-4 px-4 py-3 rounded-lg text-sm ${printMsg.ok ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
          {printMsg.ok
            ? `✓ ${printMsg.type === 'label' ? 'Etiket PDF' : 'Packing Slip PDF'} yeni sekmede açıldı.`
            : printMsg.msg}
        </div>
      )}
      <div className="flex gap-3">
        <button
          onClick={() => handlePrint('label')}
          disabled={!!printing}
          className="flex items-center gap-2 bg-slate-800 hover:bg-slate-900 disabled:opacity-60 text-white px-5 py-2.5 rounded-lg text-sm font-medium transition-colors"
        >
          {printing === 'label' ? <Spinner size="sm" /> : '🖨️'}
          Etiket Bas
        </button>
        <button
          onClick={() => handlePrint('packing_slip')}
          disabled={!!printing}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white px-5 py-2.5 rounded-lg text-sm font-medium transition-colors"
        >
          {printing === 'packing_slip' ? <Spinner size="sm" /> : '📄'}
          Packing Slip Bas
        </button>
      </div>

      {/* Finansal Detay */}
      {order.raw_json?.financial_data?.products?.length > 0 && (
        <FinancialDetail financial={order.raw_json.financial_data} />
      )}

      {/* Sipariş Geçmişi / Audit Log */}
      <div className="bg-white border border-gray-200 rounded-xl mt-6">
        <div className="px-5 py-4 border-b border-gray-100">
          <h2 className="font-semibold text-gray-800">Sipariş Geçmişi</h2>
        </div>
        {events.length === 0 ? (
          <div className="px-5 py-6 text-sm text-gray-400 text-center">Henüz olay kaydı yok.</div>
        ) : (
          <div className="px-5 py-4">
            <div className="relative">
              {/* Vertical line */}
              <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-100" />
              <ul className="space-y-4">
                {events.map((ev) => {
                  const cfg = EVENT_CONFIG[ev.event_type] || { icon: '📌', color: 'text-gray-700', bg: 'bg-gray-100' };
                  const isSystem = ['system', 'ozon-sync'].includes(ev.actor);
                  return (
                    <li key={ev.id} className="relative flex gap-3 pl-2">
                      {/* Dot */}
                      <div className={`relative z-10 flex-shrink-0 w-8 h-8 rounded-full ${cfg.bg} flex items-center justify-center text-base`}>
                        {cfg.icon}
                      </div>
                      {/* Content */}
                      <div className="flex-1 min-w-0 pt-0.5">
                        <p className={`text-sm font-medium ${cfg.color}`}>{ev.description}</p>
                        <div className="flex items-center gap-2 mt-1 flex-wrap">
                          <span className="text-xs text-gray-400">{fmtEvent(ev.created_at)}</span>
                          {isSystem ? (
                            <span className="text-xs text-gray-400">🤖 Sistem</span>
                          ) : (
                            <span className="text-xs bg-indigo-50 text-indigo-600 px-1.5 py-0.5 rounded font-medium">👤 {ev.actor}</span>
                          )}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
